// extracted by mini-css-extract-plugin
module.exports = {"address":"AirdropRow_address__14zI8","container":"AirdropRow_container__HW7DM","containerOuter":"AirdropRow_containerOuter__3wLJj"};